import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
export var AssignmentSummary = /*#__PURE__*/function (_Entity) {
  _inherits(AssignmentSummary, _Entity);

  var _super = _createSuper(AssignmentSummary);

  function AssignmentSummary() {
    _classCallCheck(this, AssignmentSummary);

    return _super.apply(this, arguments);
  }

  _createClass(AssignmentSummary, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "idNumber",
    get: function get() {
      return this.props.idNumber;
    }
  }, {
    key: "formId",
    get: function get() {
      return this.props.formId;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "duration",
    get: function get() {
      return this.props.duration;
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.props.startTime;
    }
  }, {
    key: "endTime",
    get: function get() {
      return this.props.endTime;
    }
  }, {
    key: "hasPassword",
    get: function get() {
      return this.props.hasPassword;
    }
  }, {
    key: "displayStatus",
    get: function get() {
      return this.props.displayStatus;
    }
  }, {
    key: "createdAssignmentAt",
    get: function get() {
      return this.props.createdAt;
    }
  }, {
    key: "totalAttendee",
    get: function get() {
      return this.props.totalAttendee;
    }
  }, {
    key: "getProps",
    get: function get() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, {
        argument: props.hasPassword,
        argumentName: 'hasPassword'
      }, {
        argument: props.systemStatus,
        argumentName: 'System Status'
      }, {
        argument: props.totalAttendee,
        argumentName: 'Total Attendee'
      }, {
        argument: props.createdAt,
        argumentName: 'Created At'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new AssignmentSummary(props, new UniqueEntityID(props.id)));
    }
  }]);

  return AssignmentSummary;
}(Entity);